var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassBreakNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9851 15.2364V10.5236C23.9851 10.3848 23.93 10.2516 23.8318 10.1534C23.7336 10.0552 23.6004 10 23.4615 10H12.5236C12.3846 10 12.2515 10.0552 12.1533 10.1534C12.0551 10.2516 12 10.3848 12 10.5236V15.2364C12.002 16.7341 12.5644 18.1768 13.5765 19.2808C14.5886 20.3849 15.977 21.0705 17.4688 21.2026V24.9527H15.2578C15.0707 24.9527 14.8979 25.0525 14.8044 25.2145C14.7109 25.3766 14.7109 25.5761 14.8044 25.7382C14.8979 25.9002 15.0707 26 15.2578 26H20.6687C20.8558 26 21.0287 25.9002 21.1222 25.7382C21.2157 25.5761 21.2157 25.3766 21.1222 25.2145C21.0287 25.0525 20.8558 24.9527 20.6687 24.9527H18.5161V21.2026C20.008 21.0705 21.3964 20.3849 22.4084 19.2808C23.4205 18.1768 23.983 16.734 23.9851 15.2364ZM13.0469 15.2364V11.0473H17.3614L15.8773 13.7009C15.7865 13.8631 15.7886 14.0611 15.8825 14.2215C15.9765 14.3818 16.1484 14.4802 16.3342 14.4802H18.1349L16.3091 17.1519C16.2039 17.3064 16.189 17.5052 16.2699 17.6736C16.3508 17.8421 16.5155 17.9547 16.7018 17.969C16.8881 17.9833 17.068 17.8972 17.1736 17.7431L19.5592 14.2522C19.6313 14.1468 19.6624 14.0187 19.6466 13.8919C19.6308 13.7652 19.5693 13.6487 19.4736 13.5641C19.378 13.4796 19.2547 13.433 19.1269 13.433H17.227L18.5614 11.0473H22.9378V15.2364C22.9378 16.5479 22.4168 17.8058 21.4894 18.7334C20.5619 19.6607 19.304 20.1818 17.9924 20.1818C16.6807 20.1818 15.423 19.6607 14.4954 18.7334C13.568 17.8059 13.0469 16.548 13.0469 15.2364Z",
    fill: "#A10505",
    stroke: "#A10505",
    strokeWidth: 0.363635
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassBreakNotifications);
export default __webpack_public_path__ + "static/media/glassBreak-notifications.ed07f3a9ad01b82f64c2a3849724e726.svg";
export { ForwardRef as ReactComponent };